

exports.__esModule = true;

var _squid = require('squid');

var _fi = require('xo-models/src/fi');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupAmountDirective', {
    tag: 'xo-topup-amount',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        },
        success: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token)
            };
        }
    },

    actions: {
        selectAmount: function selectAmount(amount) {
            this.models.walletPreferences.topup.amount = amount;
            this.success();
        }
    },

    lifecycle: {
        enter: function enter() {
            this.topupAmounts = _squid.$config.topup.topupAmounts;
            this.locale = _squid.$locale;
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.$locale;

_fi.$WalletPreferences;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/topup/topup-amount/directive.js
// module id = ./components/xo-wallet-components/src/topup/topup-amount/directive.js
// module chunks = 1